// import { useState, useEffect, useRef, useCallback, useMemo, memo } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   MdArrowBack,
//   MdArrowUpward,
//   MdArrowDownward,
//   MdArrowForward,
//   MdSave,
//   MdDelete,
//   MdUpload,
//   MdUndo,
//   MdPanTool,
//   MdEdit,
//   MdClose,
//   MdVisibility,
//   MdVisibilityOff,
//   MdImage,
// } from "react-icons/md";
// import Alert from "components/common/Alert";
// import { getImageUrl } from "utils/imageHelper";
// import { useFloorMap } from "./hooks/useFloorMap";
// import {
//   getStalls as fetchStalls,
//   saveStalls as apiSaveStalls,
//   updateFloorMap as apiUpdateFloorMap,
// } from "api/floorMap.api";
// import { getExhibitor } from "api/exhibitor.api";

// const CANVAS_W = 1200;
// const CANVAS_H = 800;

// const STALL_TYPES = [
//   { value: "stall", label: "Stall", color: "#93c5fd" },
//   { value: "stage", label: "Stage", color: "#c4b5fd" },
//   { value: "auditorium", label: "Auditorium", color: "#a5b4fc" },
//   { value: "cafe", label: "Café", color: "#f9a8d4" },
//   { value: "toilet", label: "Toilet", color: "#86efac" },
//   { value: "parking", label: "Parking", color: "#fde68a" },
//   { value: "entrance", label: "Entrance", color: "#6ee7b7" },
//   { value: "exit", label: "Exit", color: "#fca5a5" },
//   { value: "info", label: "Info Point", color: "#67e8f9" },
//   { value: "corridor", label: "Corridor", color: "#d1d5db" },
//   { value: "tree", label: "Tree / Park", color: "#4ade80" },
//   { value: "fountain", label: "Fountain", color: "#38bdf8" },
//   { value: "smoking", label: "Smoking Area", color: "#9ca3af" },
//   { value: "label", label: "Text Label", color: "transparent" },
//   { value: "other", label: "Other", color: "#e5e7eb" },
// ];

// const typeColor = (type) =>
//   STALL_TYPES.find((t) => t.value === type)?.color ?? "#93c5fd";

// let _tid = 0;
// const nextId = () => `tmp_${++_tid}`;

// const stallToUI = (s) => ({
//   id: s._id,
//   stall_number: s.stall_number,
//   stall_name: s.stall_name,
//   type: s.type,
//   points: s.points,
//   color: s.color,
//   image: s.image ?? null,
//   font_size: s.font_size ?? 11,
//   font_color: s.font_color ?? "#1e293b",
//   show_logo: s.show_logo ?? false,
//   exhibitor_id: s.exhibitor_id?._id || s.exhibitor_id || null,
//   exhibitor_name: s.exhibitor_id?.title || "",
//   exhibitor_logo: s.exhibitor_id?.logo_image || "",
// });

// // Memoized per-stall shape — only re-renders when this specific stall's data or selection changes
// const StallShape = memo(function StallShape({ stall, isSel, mode }) {
//   const cx = stall.points.reduce((s, p) => s + p[0], 0) / stall.points.length;
//   const cy = stall.points.reduce((s, p) => s + p[1], 0) / stall.points.length;
//   const xs = stall.points.map((p) => p[0]);
//   const ys = stall.points.map((p) => p[1]);
//   const minX = Math.min(...xs);
//   const minY = Math.min(...ys);
//   const bw = Math.max(...xs) - minX;
//   const bh = Math.max(...ys) - minY;
//   const imageUrl = stall.image ? getImageUrl(stall.image) : null;
//   const logoUrl =
//     !imageUrl && stall.show_logo && stall.exhibitor_logo
//       ? getImageUrl(stall.exhibitor_logo)
//       : null;
//   // No lower bound — the badge must stay visible even on very small stalls
//   const logoR = Math.max(Math.min(Math.min(bw, bh) * 0.28, 20), 4);
//   const polyPoints = stall.points.map(([x, y]) => `${x},${y}`).join(" ");
//   if (stall.type === "label") {
//     const cx = stall.points.reduce((s, p) => s + p[0], 0) / stall.points.length;
//     const cy = stall.points.reduce((s, p) => s + p[1], 0) / stall.points.length;

//     return (
//       <g data-stall-id={stall.id} style={{ cursor: "pointer" }}>
//         <text
//           x={cx}
//           y={cy}
//           textAnchor="middle"
//           dominantBaseline="middle"
//           fontSize={stall.font_size ?? 18}
//           fill={stall.font_color ?? "#000000"}
//           fontWeight="bold"
//           pointerEvents="none"
//         >
//           {stall.stall_name || stall.stall_number}
//         </text>
//         {isSel && (
//           <circle
//             cx={cx}
//             cy={cy}
//             r={40}
//             fill="none"
//             stroke="#1d4ed8"
//             strokeWidth={0.5}
//             strokeDasharray="4 2"
//           />
//         )}
//       </g>
//     );
//   }

//   return (
//     <g
//       data-stall-id={stall.id}
//       style={{
//         cursor: mode === "select" ? (isSel ? "grab" : "pointer") : "crosshair",
//       }}
//     >
//       {imageUrl ? (
//         <>
//           <clipPath id={`clip-img-${stall.id}`}>
//             <polygon points={polyPoints} />
//           </clipPath>
//           <image
//             href={imageUrl}
//             x={minX}
//             y={minY}
//             width={bw}
//             height={bh}
//             preserveAspectRatio="xMidYMid meet"
//             clipPath={`url(#clip-img-${stall.id})`}
//           />
//           {isSel && (
//             <polygon
//               points={polyPoints}
//               fill="none"
//               stroke="#1d4ed8"
//               strokeWidth={0.1}
//             />
//           )}
//         </>
//       ) : (
//         <polygon
//           points={polyPoints}
//           fill={stall.color}
//           fillOpacity={0.75}
//           stroke={isSel ? "#1d4ed8" : "#475569"}
//           strokeWidth={0.1}
//         />
//       )}
//       {!imageUrl && !logoUrl && (
//         <text
//           x={cx}
//           y={cy}
//           textAnchor="middle"
//           dominantBaseline="middle"
//           fontSize={stall.font_size ?? 11}
//           fill={stall.font_color ?? "#1e293b"}
//           fontWeight={isSel ? "600" : "400"}
//           pointerEvents="none"
//         >
//           {stall.stall_number}
//         </text>
//       )}
//       {!imageUrl && logoUrl && (
//         <>
//           <clipPath id={`clip-${stall.id}`}>
//             <circle cx={cx} cy={cy} r={logoR} />
//           </clipPath>
//           <image
//             href={logoUrl}
//             x={cx - logoR}
//             y={cy - logoR}
//             width={logoR * 2}
//             height={logoR * 2}
//             preserveAspectRatio="xMidYMid slice"
//             clipPath={`url(#clip-${stall.id})`}
//             pointerEvents="none"
//           />
//         </>
//       )}
//     </g>
//   );
// });

// export default function MapBuilder() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const svgRef = useRef(null);
//   const bgInputRef = useRef(null);
//   const stallImageInputRef = useRef(null);
//   const panRef = useRef(null);
//   const didPanRef = useRef(false);
//   const dragRef = useRef(null);
//   const dragGroupRef = useRef(null);
//   const didDragRef = useRef(false);
//   const cursorPtRef = useRef(null);
//   const cursorLine1Ref = useRef(null);
//   const cursorLine2Ref = useRef(null);
//   const containerRef = useRef(null); // viewport clip container
//   const wrapperRef = useRef(null); // CSS-transform target (GPU-composited)
//   const zoomRef = useRef(1);
//   const panXRef = useRef(0);
//   const panYRef = useRef(0);
//   const zoomTimerRef = useRef(null);

//   const {
//     currentMap,
//     loadFloorMapById,
//     uploadFloorBackground,
//     uploadStallImage,
//     togglePublish,
//   } = useFloorMap();

//   const [floors, setFloors] = useState([]);
//   const [activeFloor, setActiveFloor] = useState(null);
//   const [mapName, setMapName] = useState("");
//   const [mapStatus, setMapStatus] = useState("draft");

//   const [zoom, setZoom] = useState(1); // only for zoomPct display; actual zoom lives in zoomRef
//   const [isPanning, setIsPanning] = useState(false);
//   const [isDraggingStall, setIsDraggingStall] = useState(false);

//   const [mode, setMode] = useState("select");
//   const [stalls, setStalls] = useState([]);
//   const [drawPts, setDrawPts] = useState([]);
//   const [selected, setSelected] = useState(null);

//   const [saving, setSaving] = useState(false);
//   const [alert, setAlert] = useState({ type: "", message: "" });
//   const [exhibitors, setExhibitors] = useState([]);
//   const [step, setStep] = useState(5);

//   // ── derived ──────────────────────────────────────────────────────────────
//   const activeFloorData = floors.find((f) => f.floor_id === activeFloor);
//   const bgImage = activeFloorData?.background_image
//     ? getImageUrl(activeFloorData.background_image)
//     : null;
//   const zoomPct = Math.round(zoom * 100);
//   const selectedStall = stalls.find((s) => s.id === selected) ?? null;

//   const moveSelected = useCallback(
//     (dx, dy) => {
//       if (!selected) return;
//       setStalls((p) =>
//         p.map((s) =>
//           s.id !== selected
//             ? s
//             : { ...s, points: s.points.map(([x, y]) => [x + dx, y + dy]) }
//         )
//       );
//     },
//     [selected]
//   );

//   const bbox = useMemo(() => {
//     if (!selectedStall?.points?.length) return { w: 0, h: 0 };
//     const xs = selectedStall.points.map((p) => p[0]);
//     const ys = selectedStall.points.map((p) => p[1]);
//     return {
//       w: Math.round(Math.max(...xs) - Math.min(...xs)),
//       h: Math.round(Math.max(...ys) - Math.min(...ys)),
//     };
//   }, [selectedStall]);

//   // ── CSS transform helpers ─────────────────────────────────────────────────
//   const applyTransform = useCallback((z, px, py) => {
//     if (wrapperRef.current) {
//       wrapperRef.current.style.transform = `scale(${z}) translate(${-px}px, ${-py}px)`;
//     }
//   }, []);

//   const fitCanvas = useCallback(() => {
//     const rect = containerRef.current?.getBoundingClientRect();
//     if (!rect || !rect.width) return;
//     const z = Math.min(rect.width / CANVAS_W, rect.height / CANVAS_H);
//     zoomRef.current = z;
//     panXRef.current = 0;
//     panYRef.current = 0;
//     applyTransform(z, 0, 0);
//     setZoom(z);
//   }, [applyTransform]);

//   // Fit canvas on first mount
//   useEffect(() => {
//     fitCanvas();
//   }, []);

//   // ── load map ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (id) loadFloorMapById(id);
//   }, [id]);

//   useEffect(() => {
//     if (!currentMap) return;
//     setMapName(currentMap.map_name);
//     setMapStatus(currentMap.status);
//     const fl = currentMap.floors || [];
//     setFloors(fl);
//     if (fl.length > 0) setActiveFloor((prev) => prev || fl[0].floor_id);
//   }, [currentMap]);

//   useEffect(() => {
//     if (!id || !activeFloor) return;
//     fetchStalls({ floor_map_id: id, floor_id: activeFloor })
//       .then((res) => {
//         setStalls((res.data?.data || []).map(stallToUI));
//         setSelected(null);
//         setDrawPts([]);
//       })
//       .catch(() => setStalls([]));
//   }, [id, activeFloor]);

//   useEffect(() => {
//     const cid = localStorage.getItem("company_id");
//     if (cid)
//       getExhibitor(cid)
//         .then((r) => setExhibitors(r?.data || []))
//         .catch(() => {});
//   }, []);

//   // ── zoom ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const el = containerRef.current;
//     if (!el) return;
//     const onWheel = (e) => {
//       e.preventDefault();
//       const factor = e.deltaY > 0 ? 0.89 : 1.12;
//       const rect = el.getBoundingClientRect();
//       const z0 = zoomRef.current;
//       const z1 = z0 * factor;
//       // Keep the canvas point under cursor fixed
//       const cx = (e.clientX - rect.left) / z0 + panXRef.current;
//       const cy = (e.clientY - rect.top) / z0 + panYRef.current;
//       panXRef.current = cx - (e.clientX - rect.left) / z1;
//       panYRef.current = cy - (e.clientY - rect.top) / z1;
//       zoomRef.current = z1;
//       // GPU compositor handles this — zero repaint of SVG content
//       if (wrapperRef.current) {
//         wrapperRef.current.style.transform = `scale(${z1}) translate(${-panXRef.current}px, ${-panYRef.current}px)`;
//       }
//       // Update zoom% indicator after scroll settles
//       clearTimeout(zoomTimerRef.current);
//       zoomTimerRef.current = setTimeout(() => setZoom(z1), 150);
//     };
//     el.addEventListener("wheel", onWheel, { passive: false });
//     return () => {
//       el.removeEventListener("wheel", onWheel);
//       clearTimeout(zoomTimerRef.current);
//     };
//   }, []);

//   // ── keyboard ──────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const onKey = (e) => {
//       const tag = e.target.tagName;
//       if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return;
//       if (e.key === "Escape") {
//         setDrawPts([]);
//         cursorPtRef.current = null;
//         setMode("select");
//       }
//       if (e.key === "Enter" && mode === "draw" && drawPts.length >= 3)
//         closePolygon();
//       if ((e.key === "Delete" || e.key === "Backspace") && selected)
//         deleteSelected();
//       const arrowStep = e.shiftKey ? 20 : e.ctrlKey ? 50 : step;
//       if (selected) {
//         if (e.key === "ArrowUp") {
//           e.preventDefault();
//           moveSelected(0, -arrowStep);
//         }
//         if (e.key === "ArrowDown") {
//           e.preventDefault();
//           moveSelected(0, arrowStep);
//         }
//         if (e.key === "ArrowLeft") {
//           e.preventDefault();
//           moveSelected(-arrowStep, 0);
//         }
//         if (e.key === "ArrowRight") {
//           e.preventDefault();
//           moveSelected(arrowStep, 0);
//         }
//       }
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [mode, drawPts, selected, step, moveSelected]);

//   // Collapse cursor preview lines to invisible when draw mode exits or drawing is reset
//   const resetCursorLines = () => {
//     ["x1", "y1", "x2", "y2"].forEach((a) => {
//       cursorLine1Ref.current?.setAttribute(a, "0");
//       cursorLine2Ref.current?.setAttribute(a, "0");
//     });
//   };
//   useEffect(() => {
//     if (mode !== "draw" || drawPts.length === 0) resetCursorLines();
//   }, [mode, drawPts.length]);

//   // ── coord helpers ─────────────────────────────────────────────────────────
//   // Manual math — avoids getScreenCTM() which flushes layout on every call
//   const getCanvasPt = useCallback((e) => {
//     const rect = containerRef.current?.getBoundingClientRect() ?? {
//       left: 0,
//       top: 0,
//     };
//     return [
//       (e.clientX - rect.left) / zoomRef.current + panXRef.current,
//       (e.clientY - rect.top) / zoomRef.current + panYRef.current,
//     ];
//   }, []);

//   const toViewport = useCallback(([cx, cy]) => {
//     const rect = containerRef.current?.getBoundingClientRect() ?? {
//       left: 0,
//       top: 0,
//     };
//     return [
//       (cx - panXRef.current) * zoomRef.current + rect.left,
//       (cy - panYRef.current) * zoomRef.current + rect.top,
//     ];
//   }, []);

//   // ── svg mouse handlers ────────────────────────────────────────────────────
//   const handleSvgMouseDown = (e) => {
//     if (mode === "select") {
//       // Check if click landed on a stall group (event delegation replaces per-<g> handlers)
//       const stallGroup = e.target.closest("[data-stall-id]");
//       if (stallGroup) {
//         const stallId = stallGroup.dataset.stallId;
//         setSelected(stallId);
//         didDragRef.current = false;
//         dragRef.current = {
//           stallId,
//           sx: e.clientX,
//           sy: e.clientY,
//           pts: stalls.find((s) => s.id === stallId)?.points || [],
//           moved: false,
//         };
//         dragGroupRef.current = stallGroup;
//         setIsDraggingStall(true);
//         return;
//       }
//       // Canvas — start panning
//       setIsPanning(true);
//       didPanRef.current = false;
//       panRef.current = {
//         sx: e.clientX,
//         sy: e.clientY,
//         startPanX: panXRef.current,
//         startPanY: panYRef.current,
//       };
//     }
//   };

//   const handleSvgMouseMove = (e) => {
//     if (dragRef.current) {
//       const d = dragRef.current;
//       const z = zoomRef.current;
//       const dx = (e.clientX - d.sx) / z;
//       const dy = (e.clientY - d.sy) / z;
//       if (Math.abs(e.clientX - d.sx) > 3 || Math.abs(e.clientY - d.sy) > 3) {
//         d.moved = true;
//         didDragRef.current = true;
//       }
//       d.lastDx = dx;
//       d.lastDy = dy;
//       // Move the whole <g> in canvas-unit space — no React re-render
//       if (dragGroupRef.current) {
//         dragGroupRef.current.setAttribute(
//           "transform",
//           `translate(${dx},${dy})`
//         );
//       }
//       return;
//     }
//     if (isPanning && panRef.current) {
//       const p = panRef.current;
//       const z = zoomRef.current;
//       const dx = (e.clientX - p.sx) / z;
//       const dy = (e.clientY - p.sy) / z;
//       if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) didPanRef.current = true;
//       panXRef.current = p.startPanX - dx;
//       panYRef.current = p.startPanY - dy;
//       // GPU compositor applies the transform — zero SVG repaint
//       if (wrapperRef.current) {
//         wrapperRef.current.style.transform = `scale(${z}) translate(${-panXRef.current}px, ${-panYRef.current}px)`;
//       }
//     }
//     if (mode === "draw") {
//       const pt = getCanvasPt(e);
//       cursorPtRef.current = pt;
//       if (drawPts.length > 0) {
//         const last = drawPts[drawPts.length - 1];
//         if (cursorLine1Ref.current) {
//           cursorLine1Ref.current.setAttribute("x1", String(last[0]));
//           cursorLine1Ref.current.setAttribute("y1", String(last[1]));
//           cursorLine1Ref.current.setAttribute("x2", String(pt[0]));
//           cursorLine1Ref.current.setAttribute("y2", String(pt[1]));
//           cursorLine1Ref.current.style.display = "";
//         }
//         if (drawPts.length >= 3 && cursorLine2Ref.current) {
//           cursorLine2Ref.current.setAttribute("x1", String(drawPts[0][0]));
//           cursorLine2Ref.current.setAttribute("y1", String(drawPts[0][1]));
//           cursorLine2Ref.current.setAttribute("x2", String(pt[0]));
//           cursorLine2Ref.current.setAttribute("y2", String(pt[1]));
//           cursorLine2Ref.current.style.display = "";
//         } else if (cursorLine2Ref.current) {
//           cursorLine2Ref.current.style.display = "none";
//         }
//       }
//     }
//   };

//   const handleSvgMouseUp = () => {
//     if (dragRef.current?.moved && dragRef.current.lastDx !== undefined) {
//       const d = dragRef.current;
//       setStalls((prev) =>
//         prev.map((s) =>
//           s.id !== d.stallId
//             ? s
//             : {
//                 ...s,
//                 points: d.pts.map(([x, y]) => [x + d.lastDx, y + d.lastDy]),
//               }
//         )
//       );
//     }
//     if (dragGroupRef.current) {
//       dragGroupRef.current.removeAttribute("transform");
//       dragGroupRef.current = null;
//     }
//     dragRef.current = null;
//     setIsDraggingStall(false);
//     setIsPanning(false);
//   };

//   const handleSvgClick = (e) => {
//     if (mode === "select") {
//       if (didPanRef.current || didDragRef.current) return;
//       const stallGroup = e.target.closest("[data-stall-id]");
//       if (stallGroup) {
//         setSelected(stallGroup.dataset.stallId);
//       } else {
//         const tag = e.target.tagName;
//         if (
//           tag === "svg" ||
//           tag === "image" ||
//           tag === "rect" ||
//           tag === "line"
//         )
//           setSelected(null);
//       }
//       return;
//     }
//     if (mode !== "draw") return;
//     const pt = getCanvasPt(e);
//     if (drawPts.length >= 3) {
//       const [fpx, fpy] = toViewport(drawPts[0]);
//       if (Math.hypot(e.clientX - fpx, e.clientY - fpy) < 16) {
//         closePolygon();
//         return;
//       }
//     }
//     setDrawPts((prev) => [...prev, pt]);
//   };

//   // ── polygon drawing ───────────────────────────────────────────────────────
//   const closePolygon = () => {
//     if (drawPts.length < 3) return;
//     const newS = {
//       id: nextId(),
//       stall_number: `S${stalls.length + 1}`,
//       stall_name: "",
//       type: "stall",
//       points: drawPts,
//       color: typeColor("stall"),
//       image: null,
//       font_size: 11,
//       font_color: "#1e293b",
//       show_logo: false,
//       exhibitor_id: null,
//       exhibitor_name: "",
//       exhibitor_logo: "",
//     };
//     setStalls((p) => [...p, newS]);
//     setSelected(newS.id);
//     setMode("select");
//     setDrawPts([]);
//     cursorPtRef.current = null;
//   };

//   const deleteSelected = () => {
//     setStalls((p) => p.filter((s) => s.id !== selected));
//     setSelected(null);
//   };

//   // ── preset shapes ─────────────────────────────────────────────────────────
//   // Reads refs directly so it always reflects the current viewport center, not a stale state snapshot
//   const viewportCenter = () => {
//     const rect = containerRef.current?.getBoundingClientRect();
//     const cw = rect?.width ?? CANVAS_W;
//     const ch = rect?.height ?? CANVAS_H;
//     return [
//       panXRef.current + cw / (2 * (zoomRef.current || 1)),
//       panYRef.current + ch / (2 * (zoomRef.current || 1)),
//     ];
//   };

//   const addStall = (points) => {
//     const s = {
//       id: nextId(),
//       stall_number: `S${stalls.length + 1}`,
//       stall_name: "",
//       type: "stall",
//       points,
//       color: typeColor("stall"),
//       image: null,
//       font_size: 11,
//       font_color: "#1e293b",
//       show_logo: false,
//       exhibitor_id: null,
//       exhibitor_name: "",
//       exhibitor_logo: "",
//     };
//     setStalls((p) => [...p, s]);
//     setSelected(s.id);
//     setMode("select");
//   };

//   const addRect = (w = 150, h = 100) => {
//     const [cx, cy] = viewportCenter();
//     addStall([
//       [cx - w / 2, cy - h / 2],
//       [cx + w / 2, cy - h / 2],
//       [cx + w / 2, cy + h / 2],
//       [cx - w / 2, cy + h / 2],
//     ]);
//   };
//   const addSquare = (n = 100) => addRect(n, n);
//   const addCircle = (r = 60) => {
//     const [cx, cy] = viewportCenter();
//     addStall(
//       Array.from({ length: 16 }, (_, i) => {
//         const a = (i / 16) * 2 * Math.PI;
//         return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
//       })
//     );
//   };
//   const addTriangle = (n = 120) => {
//     const [cx, cy] = viewportCenter();
//     addStall([
//       [cx, cy - n * 0.6],
//       [cx + n / 2, cy + n * 0.4],
//       [cx - n / 2, cy + n * 0.4],
//     ]);
//   };
//   const addLShape = (n = 120) => {
//     const [cx, cy] = viewportCenter();
//     addStall([
//       [cx - n / 2, cy - n / 2],
//       [cx, cy - n / 2],
//       [cx, cy],
//       [cx + n / 2, cy],
//       [cx + n / 2, cy + n / 2],
//       [cx - n / 2, cy + n / 2],
//     ]);
//   };

//   // ── property update ───────────────────────────────────────────────────────
//   const updateSel = (field, val) =>
//     setStalls((p) =>
//       p.map((s) => {
//         if (s.id !== selected) return s;
//         const u = { ...s, [field]: val };
//         if (field === "type") u.color = typeColor(val);
//         if (field === "exhibitor_id") {
//           const ex = exhibitors.find((e) => e._id === val);
//           u.exhibitor_name = ex?.title || "";
//           u.exhibitor_logo = ex?.logo_image || "";
//           // reset show_logo if exhibitor cleared
//           if (!val) u.show_logo = false;
//         }
//         return u;
//       })
//     );

//   const resizeSel = (nw, nh) => {
//     if (!selectedStall || nw <= 0 || nh <= 0) return;
//     const xs = selectedStall.points.map((p) => p[0]);
//     const ys = selectedStall.points.map((p) => p[1]);
//     const cx = (Math.min(...xs) + Math.max(...xs)) / 2;
//     const cy = (Math.min(...ys) + Math.max(...ys)) / 2;
//     const ow = Math.max(...xs) - Math.min(...xs);
//     const oh = Math.max(...ys) - Math.min(...ys);
//     if (!ow || !oh) return;
//     setStalls((p) =>
//       p.map((s) =>
//         s.id !== selected
//           ? s
//           : {
//               ...s,
//               points: s.points.map(([x, y]) => [
//                 cx + (x - cx) * (nw / ow),
//                 cy + (y - cy) * (nh / oh),
//               ]),
//             }
//       )
//     );
//   };

//   // ── background ────────────────────────────────────────────────────────────
//   const handleBgUpload = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file || !activeFloor) return;
//     try {
//       const res = await uploadFloorBackground(id, activeFloor, file);
//       const imgPath = res.data?.background_image;
//       if (imgPath)
//         setFloors((p) =>
//           p.map((f) =>
//             f.floor_id === activeFloor ? { ...f, background_image: imgPath } : f
//           )
//         );
//       setAlert({ type: "success", message: "Background uploaded" });
//     } catch {
//       setAlert({ type: "error", message: "Upload failed" });
//     } finally {
//       e.target.value = "";
//     }
//   };

//   const handleRemoveBg = async () => {
//     const updated = floors.map((f) =>
//       f.floor_id === activeFloor ? { ...f, background_image: null } : f
//     );
//     try {
//       await apiUpdateFloorMap(id, {
//         floors: updated,
//         updated_by: localStorage.getItem("user_id") || null,
//       });
//       setFloors(updated);
//       setAlert({ type: "success", message: "Background removed" });
//     } catch {
//       setAlert({ type: "error", message: "Failed to remove background" });
//     }
//   };

//   // ── stall image ───────────────────────────────────────────────────────────
//   const handleStallImageUpload = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file || !selected) return;
//     try {
//       const res = await uploadStallImage(file);
//       const imgPath = res.data?.image;
//       if (imgPath) updateSel("image", imgPath);
//       setAlert({ type: "success", message: "Image uploaded" });
//     } catch {
//       setAlert({ type: "error", message: "Image upload failed" });
//     } finally {
//       e.target.value = "";
//     }
//   };

//   const handleRemoveStallImage = () => updateSel("image", null);

//   // ── save ──────────────────────────────────────────────────────────────────
//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       await apiSaveStalls({
//         floor_map_id: id,
//         floor_id: activeFloor,
//         company_id: localStorage.getItem("company_id") || null,
//         updated_by: localStorage.getItem("user_id") || null,
//         stalls: stalls.map(
//           ({
//             stall_number,
//             stall_name,
//             type,
//             points,
//             color,
//             image,
//             font_size,
//             font_color,
//             show_logo,
//             exhibitor_id,
//           }) => ({
//             stall_number,
//             stall_name,
//             type,
//             points,
//             color,
//             image: image || null,
//             font_size: font_size ?? 11,
//             font_color: font_color ?? "#1e293b",
//             show_logo: show_logo ?? false,
//             exhibitor_id: exhibitor_id || null,
//           })
//         ),
//       });
//       setAlert({ type: "success", message: "Stalls saved" });
//       const r = await fetchStalls({ floor_map_id: id, floor_id: activeFloor });
//       setStalls((r.data?.data || []).map(stallToUI));
//     } catch {
//       setAlert({ type: "error", message: "Failed to save stalls" });
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ── publish ───────────────────────────────────────────────────────────────
//   const handlePublish = async () => {
//     const newStatus = mapStatus === "published" ? "draft" : "published";
//     try {
//       await togglePublish(id, {
//         status: newStatus,
//         updated_by: localStorage.getItem("user_id") || null,
//       });
//       setMapStatus(newStatus);
//       setAlert({
//         type: "success",
//         message: newStatus === "published" ? "Map published" : "Set to draft",
//       });
//     } catch {
//       setAlert({ type: "error", message: "Failed to update status" });
//     }
//   };
//   const addTextLabel = (cx, cy) => {
//     const label = {
//       id: nextId(),
//       stall_number: `L${stalls.length + 1}`,
//       stall_name: "New Label",
//       type: "label",
//       points: [[cx, cy]], // Single point
//       color: "transparent",
//       image: null,
//       font_size: 18,
//       font_color: "#000000",
//       show_logo: false,
//       exhibitor_id: null,
//       exhibitor_name: "",
//       exhibitor_logo: "",
//     };
//     setStalls((p) => [...p, label]);
//     setSelected(label.id);
//     setMode("select");
//   };

//   // ─────────────────────────────────────────────────────────────────────────
//   return (
//     <div className="fixed inset-0 z-40 flex flex-col bg-gray-100">
//       {alert.message && (
//         <Alert
//           type={alert.type}
//           message={alert.message}
//           onClose={() => setAlert({ type: "", message: "" })}
//           autoClose
//         />
//       )}

//       {/* ── Top bar ── */}
//       <div className="flex shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 py-2 shadow-sm">
//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => navigate("/admin/floor-map")}
//             className="flex items-center gap-1 rounded px-2 py-1 text-sm text-gray-600 hover:bg-gray-100"
//           >
//             <MdArrowBack size={18} /> Back
//           </button>
//           <span className="font-semibold text-gray-800">{mapName}</span>
//           <span
//             className={`rounded-full px-2 py-0.5 text-xs font-medium ${
//               mapStatus === "published"
//                 ? "bg-green-100 text-green-700"
//                 : "bg-yellow-100 text-yellow-700"
//             }`}
//           >
//             {mapStatus}
//           </span>
//         </div>

//         <div className="flex flex-wrap items-center justify-end gap-2">
//           {/* Mode */}
//           <div className="flex overflow-hidden rounded border border-gray-300">
//             {[
//               ["select", "Select", <MdPanTool size={13} />],
//               ["draw", "Draw", <MdEdit size={13} />],
//             ].map(([m, lbl, ico]) => (
//               <button
//                 key={m}
//                 className={`flex items-center gap-1 px-3 py-1.5 text-sm ${
//                   mode === m
//                     ? "bg-blue-600 text-white"
//                     : "bg-white text-gray-600 hover:bg-gray-50"
//                 }`}
//                 onClick={() => {
//                   setMode(m);
//                   setDrawPts([]);
//                 }}
//               >
//                 {ico} {lbl}
//               </button>
//             ))}
//           </div>

//           {/* Preset shapes */}
//           <div className="flex items-center gap-1 rounded border border-gray-200 bg-gray-50 px-2 py-1">
//             <span className="mr-1 text-xs text-gray-400">Shape:</span>
//             {[
//               ["Rect", () => addRect()],
//               ["Square", () => addSquare()],
//               ["Circle", () => addCircle()],
//               ["Tri", () => addTriangle()],
//               ["L", () => addLShape()],
//             ].map(([lbl, fn]) => (
//               <button
//                 key={lbl}
//                 onClick={fn}
//                 className="rounded border border-gray-300 bg-white px-2 py-0.5 text-xs hover:border-blue-300 hover:bg-blue-50"
//               >
//                 {lbl}
//               </button>
//             ))}
//           </div>

//           <button
//             onClick={fitCanvas}
//             className="rounded border border-gray-300 px-2 py-1.5 text-xs text-gray-600 hover:bg-gray-50"
//           >
//             Fit
//           </button>

//           <button
//             onClick={handlePublish}
//             className={`rounded px-3 py-1.5 text-sm text-white ${
//               mapStatus === "published"
//                 ? "bg-yellow-500 hover:bg-yellow-600"
//                 : "bg-green-600 hover:bg-green-700"
//             }`}
//           >
//             {mapStatus === "published" ? "Unpublish" : "Publish"}
//           </button>
//           <button
//             onClick={() => {
//               if (!selectedStall) {
//                 const [cx, cy] = viewportCenter();
//                 addTextLabel(cx, cy);
//               }
//             }}
//             className="flex items-center gap-1 rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-50"
//           >
//             <MdEdit size={16} /> Add Text
//           </button>

//           <button
//             onClick={handleSave}
//             disabled={saving}
//             className="flex items-center gap-1 rounded bg-blue-600 px-4 py-1.5 text-sm text-white hover:bg-blue-700 disabled:opacity-60"
//           >
//             <MdSave size={16} />
//             {saving ? "Saving…" : "Save Floor"}
//           </button>
//         </div>
//       </div>

//       {/* ── Floor tabs ── */}
//       <div className="flex min-h-[36px] shrink-0 items-center gap-1 border-b border-gray-200 bg-white px-4 py-1">
//         {floors.map((f) => (
//           <button
//             key={f.floor_id}
//             onClick={() => {
//               setActiveFloor(f.floor_id);
//               setSelected(null);
//               setDrawPts([]);
//             }}
//             className={`rounded-t px-4 py-1 text-sm font-medium ${
//               activeFloor === f.floor_id
//                 ? "border-b-2 border-blue-600 text-blue-600"
//                 : "text-gray-500 hover:text-gray-700"
//             }`}
//           >
//             {f.floor_label}
//           </button>
//         ))}

//         <div className="ml-auto flex items-center gap-2">
//           {mode === "draw" && drawPts.length > 0 && (
//             <>
//               <span className="text-xs font-medium text-blue-600">
//                 {drawPts.length} pts — click green dot or Enter to close
//               </span>
//               <button
//                 onClick={() => setDrawPts((p) => p.slice(0, -1))}
//                 className="flex items-center gap-1 rounded border border-gray-300 px-2 py-0.5 text-xs hover:bg-gray-50"
//               >
//                 <MdUndo size={13} /> Undo
//               </button>
//               <button
//                 onClick={closePolygon}
//                 disabled={drawPts.length < 3}
//                 className="rounded bg-blue-600 px-2 py-0.5 text-xs text-white hover:bg-blue-700 disabled:opacity-50"
//               >
//                 Close (Enter)
//               </button>
//             </>
//           )}
//           <input
//             ref={bgInputRef}
//             type="file"
//             accept="image/*"
//             className="hidden"
//             onChange={handleBgUpload}
//           />
//           <button
//             onClick={() => bgInputRef.current?.click()}
//             className="flex items-center gap-1 rounded border border-gray-300 px-2 py-0.5 text-xs text-gray-600 hover:bg-gray-50"
//           >
//             <MdUpload size={13} /> Upload BG
//           </button>
//           {activeFloorData?.background_image && (
//             <button
//               onClick={handleRemoveBg}
//               className="flex items-center gap-1 rounded border border-red-300 px-2 py-0.5 text-xs text-red-600 hover:bg-red-50"
//             >
//               <MdClose size={13} /> Remove BG
//             </button>
//           )}
//         </div>
//       </div>

//       {/* ── Main ── */}
//       <div className="flex flex-1 overflow-hidden">
//         {/* Canvas */}
//         <div className="relative flex-1 overflow-hidden bg-gray-300">
//           {mode === "draw" && drawPts.length === 0 && (
//             <div className="pointer-events-none absolute left-1/2 top-3 z-10 -translate-x-1/2 rounded bg-blue-600 px-3 py-1 text-xs text-white shadow">
//               Click canvas to start drawing · use preset shapes above for quick
//               add
//             </div>
//           )}
//           <div className="absolute bottom-2 right-2 z-10 rounded bg-white/80 px-2 py-0.5 text-xs text-gray-500 shadow">
//             {zoomPct}% · {stalls.length} shape{stalls.length !== 1 ? "s" : ""}
//           </div>

//           {/* D-pad */}
//           {selectedStall && (
//             <div className="absolute bottom-10 left-4 z-10 select-none rounded-xl border border-gray-200 bg-white/95 p-2 shadow-lg">
//               <div className="mb-0.5 flex justify-center">
//                 <button
//                   onMouseDown={(e) => e.stopPropagation()}
//                   onClick={() => moveSelected(0, -step)}
//                   className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
//                 >
//                   <MdArrowUpward size={18} />
//                 </button>
//               </div>
//               <div className="mb-0.5 flex items-center gap-0.5">
//                 <button
//                   onMouseDown={(e) => e.stopPropagation()}
//                   onClick={() => moveSelected(-step, 0)}
//                   className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
//                 >
//                   <MdArrowBack size={18} />
//                 </button>
//                 <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-100 text-xs font-semibold text-gray-500">
//                   {step}
//                 </div>
//                 <button
//                   onMouseDown={(e) => e.stopPropagation()}
//                   onClick={() => moveSelected(step, 0)}
//                   className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
//                 >
//                   <MdArrowForward size={18} />
//                 </button>
//               </div>
//               <div className="mb-1.5 flex justify-center">
//                 <button
//                   onMouseDown={(e) => e.stopPropagation()}
//                   onClick={() => moveSelected(0, step)}
//                   className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
//                 >
//                   <MdArrowDownward size={18} />
//                 </button>
//               </div>
//               <div className="flex items-center justify-center gap-1">
//                 {[1, 5, 10, 20].map((s) => (
//                   <button
//                     key={s}
//                     onMouseDown={(e) => e.stopPropagation()}
//                     onClick={() => setStep(s)}
//                     className={`h-5 w-7 rounded text-[10px] font-medium transition-colors ${
//                       step === s
//                         ? "bg-blue-600 text-white"
//                         : "bg-gray-100 text-gray-600 hover:bg-gray-200"
//                     }`}
//                   >
//                     {s}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Container clips overflow; receives all pointer events */}
//           <div
//             ref={containerRef}
//             className="absolute inset-0 overflow-hidden"
//             style={{
//               cursor:
//                 mode === "draw"
//                   ? "crosshair"
//                   : isDraggingStall || isPanning
//                   ? "grabbing"
//                   : "grab",
//             }}
//             onMouseDown={handleSvgMouseDown}
//             onMouseMove={handleSvgMouseMove}
//             onMouseUp={handleSvgMouseUp}
//             onMouseLeave={handleSvgMouseUp}
//             onClick={handleSvgClick}
//           >
//             {/* GPU-composited transform wrapper — pan/zoom applied here, zero SVG repaint */}
//             <div
//               ref={wrapperRef}
//               style={{
//                 transformOrigin: "0 0",
//                 willChange: "transform",
//                 position: "absolute",
//               }}
//             >
//               <svg
//                 ref={svgRef}
//                 width={CANVAS_W}
//                 height={CANVAS_H}
//                 style={{ display: "block", overflow: "visible" }}
//               >
//                 {/* Background */}
//                 {bgImage ? (
//                   <image
//                     href={bgImage}
//                     x={0}
//                     y={0}
//                     width={CANVAS_W}
//                     height={CANVAS_H}
//                     preserveAspectRatio="xMidYMid meet"
//                   />
//                 ) : (
//                   <>
//                     <rect
//                       x={0}
//                       y={0}
//                       width={CANVAS_W}
//                       height={CANVAS_H}
//                       fill="#f8fafc"
//                       stroke="#e2e8f0"
//                       strokeWidth={1}
//                     />
//                     <text
//                       x={CANVAS_W / 2}
//                       y={CANVAS_H / 2}
//                       textAnchor="middle"
//                       dominantBaseline="middle"
//                       fontSize={14}
//                       fill="#94a3b8"
//                     >
//                       No background — upload a floor plan image (optional)
//                     </text>
//                   </>
//                 )}

//                 {/* Grid */}
//                 {Array.from({ length: 11 }, (_, i) => (
//                   <line
//                     key={`v${i}`}
//                     x1={(i + 1) * 100}
//                     y1={0}
//                     x2={(i + 1) * 100}
//                     y2={CANVAS_H}
//                     stroke="#e2e8f0"
//                     strokeWidth={0.5}
//                   />
//                 ))}
//                 {Array.from({ length: 7 }, (_, i) => (
//                   <line
//                     key={`h${i}`}
//                     x1={0}
//                     y1={(i + 1) * 100}
//                     x2={CANVAS_W}
//                     y2={(i + 1) * 100}
//                     stroke="#e2e8f0"
//                     strokeWidth={0.5}
//                   />
//                 ))}

//                 {/* Stalls — each shape is memoized; only re-renders when its own data or selection changes */}
//                 {stalls.map((stall) => (
//                   <StallShape
//                     key={stall.id}
//                     stall={stall}
//                     isSel={stall.id === selected}
//                     mode={mode}
//                   />
//                 ))}

//                 {/* Cursor preview lines — always in DOM, coordinates + visibility updated via ref (no React re-render on mousemove) */}
//                 <line
//                   ref={cursorLine1Ref}
//                   stroke="#2563eb"
//                   strokeWidth={1.5}
//                   strokeDasharray="4 2"
//                   pointerEvents="none"
//                 />
//                 <line
//                   ref={cursorLine2Ref}
//                   stroke="#16a34a"
//                   strokeWidth={1}
//                   strokeDasharray="4 2"
//                   strokeOpacity={0.5}
//                   pointerEvents="none"
//                 />

//                 {/* Drawing preview */}
//                 {drawPts.length > 0 && (
//                   <>
//                     {drawPts.length >= 2 && (
//                       <polyline
//                         points={drawPts.map(([x, y]) => `${x},${y}`).join(" ")}
//                         fill="none"
//                         stroke="#2563eb"
//                         strokeWidth={1.5}
//                         strokeDasharray="6 3"
//                         pointerEvents="none"
//                       />
//                     )}
//                     {drawPts.map(([x, y], i) => (
//                       <circle
//                         key={i}
//                         cx={x}
//                         cy={y}
//                         r={i === 0 ? 7 : 4}
//                         fill={i === 0 ? "#16a34a" : "#2563eb"}
//                         stroke="white"
//                         strokeWidth={1.5}
//                         pointerEvents="none"
//                       />
//                     ))}
//                   </>
//                 )}
//               </svg>
//             </div>
//             {/* end wrapperRef */}
//           </div>
//           {/* end containerRef */}
//         </div>

//         {/* ── Properties panel ── */}
//         <div className="w-64 shrink-0 overflow-y-auto border-l border-gray-200 bg-white p-4">
//           {selectedStall ? (
//             <div className="flex flex-col gap-3">
//               <div className="flex items-center justify-between">
//                 <h3 className="font-semibold text-gray-800">Properties</h3>
//                 <button
//                   onClick={deleteSelected}
//                   title="Delete (Del)"
//                   className="rounded p-1 text-red-500 hover:bg-red-50"
//                 >
//                   <MdDelete size={18} />
//                 </button>
//               </div>

//               {[
//                 ["Stall Number", "stall_number"],
//                 ["Stall Name", "stall_name"],
//               ].map(([lbl, field]) => (
//                 <div key={field}>
//                   <label className="mb-1 block text-xs font-medium text-gray-600">
//                     {lbl}
//                   </label>
//                   <input
//                     className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     value={selectedStall[field]}
//                     onChange={(e) => updateSel(field, e.target.value)}
//                     placeholder={
//                       field === "stall_name" ? "Optional display name" : ""
//                     }
//                   />
//                 </div>
//               ))}

//               <div>
//                 <label className="mb-1 block text-xs font-medium text-gray-600">
//                   Type
//                 </label>
//                 <select
//                   className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   value={selectedStall.type}
//                   onChange={(e) => updateSel("type", e.target.value)}
//                 >
//                   {STALL_TYPES.map((t) => (
//                     <option key={t.value} value={t.value}>
//                       {t.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Size resize */}
//               <div>
//                 <label className="mb-1 block text-xs font-medium text-gray-600">
//                   Size (W × H)
//                 </label>
//                 <div className="flex items-center gap-1">
//                   <input
//                     type="number"
//                     min={10}
//                     max={CANVAS_W}
//                     className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     value={bbox.w}
//                     onChange={(e) => resizeSel(Number(e.target.value), bbox.h)}
//                   />
//                   <span className="shrink-0 text-gray-400">×</span>
//                   <input
//                     type="number"
//                     min={10}
//                     max={CANVAS_H}
//                     className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     value={bbox.h}
//                     onChange={(e) => resizeSel(bbox.w, Number(e.target.value))}
//                   />
//                 </div>
//                 <p className="mt-0.5 text-xs text-gray-400">
//                   Drag shape to reposition
//                 </p>
//               </div>

//               <div>
//                 <label className="mb-1 block text-xs font-medium text-gray-600">
//                   Box Image
//                 </label>
//                 {selectedStall.image ? (
//                   <div className="flex items-center gap-2">
//                     <img
//                       src={getImageUrl(selectedStall.image)}
//                       alt="Box"
//                       className="h-12 w-12 rounded border border-gray-300 object-cover"
//                     />
//                     <button
//                       onClick={handleRemoveStallImage}
//                       className="flex items-center gap-1 rounded border border-red-300 px-2 py-1 text-xs text-red-600 hover:bg-red-50"
//                     >
//                       <MdClose size={13} /> Remove
//                     </button>
//                   </div>
//                 ) : (
//                   <button
//                     onClick={() => stallImageInputRef.current?.click()}
//                     className="flex w-full items-center justify-center gap-1 rounded border border-dashed border-gray-300 px-2 py-2 text-xs text-gray-500 hover:border-blue-400 hover:text-blue-600"
//                   >
//                     <MdImage size={14} /> Upload image
//                   </button>
//                 )}
//                 <input
//                   ref={stallImageInputRef}
//                   type="file"
//                   accept="image/*"
//                   className="hidden"
//                   onChange={handleStallImageUpload}
//                 />
//                 <p className="mt-0.5 text-xs text-gray-400">
//                   Shown instead of the colored box
//                 </p>
//               </div>

//               <div>
//                 <label className="mb-1 block text-xs font-medium text-gray-600">
//                   Color
//                 </label>
//                 <div className="flex items-center gap-2">
//                   <input
//                     type="color"
//                     className="h-8 w-10 cursor-pointer rounded border border-gray-300"
//                     value={selectedStall.color}
//                     onChange={(e) => updateSel("color", e.target.value)}
//                   />
//                   <span className="text-xs text-gray-500">
//                     {selectedStall.color}
//                   </span>
//                 </div>
//                 <div className="mt-1.5 flex flex-wrap gap-1">
//                   {STALL_TYPES.map((t) => (
//                     <button
//                       key={t.value}
//                       title={t.label}
//                       style={{ backgroundColor: t.color }}
//                       className="h-5 w-5 rounded-full border border-gray-300 transition-transform hover:scale-125"
//                       onClick={() => updateSel("color", t.color)}
//                     />
//                   ))}
//                 </div>
//               </div>

//               <div>
//                 <label className="mb-1 block text-xs font-medium text-gray-600">
//                   Label
//                 </label>
//                 <div className="flex items-center gap-2">
//                   <div className="flex flex-1 flex-col gap-0.5">
//                     <span className="text-[10px] text-gray-400">Size</span>
//                     <input
//                       type="number"
//                       min={1}
//                       max={48}
//                       className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       value={selectedStall.font_size ?? 11}
//                       onChange={(e) =>
//                         updateSel(
//                           "font_size",
//                           Math.max(1, Math.min(48, Number(e.target.value)))
//                         )
//                       }
//                     />
//                   </div>
//                   <div className="flex flex-col gap-0.5">
//                     <span className="text-[10px] text-gray-400">Color</span>
//                     <input
//                       type="color"
//                       className="h-[34px] w-10 cursor-pointer rounded border border-gray-300"
//                       value={selectedStall.font_color ?? "#1e293b"}
//                       onChange={(e) => updateSel("font_color", e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <label className="mb-1 block text-xs font-medium text-gray-600">
//                   Exhibitor
//                 </label>
//                 <select
//                   className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   value={selectedStall.exhibitor_id || ""}
//                   onChange={(e) =>
//                     updateSel("exhibitor_id", e.target.value || null)
//                   }
//                 >
//                   <option value="">— None —</option>
//                   {exhibitors.map((ex) => (
//                     <option key={ex._id} value={ex._id}>
//                       {ex.title}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Show Logo toggle — only visible when exhibitor is assigned */}
//               {selectedStall.exhibitor_id && (
//                 <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
//                   <div className="flex items-center justify-between">
//                     <div>
//                       <p className="text-xs font-semibold text-gray-700">
//                         Show Logo on Map
//                       </p>
//                       <p className="mt-0.5 text-[11px] text-gray-400">
//                         Display exhibitor logo over this stall
//                       </p>
//                     </div>
//                     <button
//                       onClick={() =>
//                         updateSel("show_logo", !selectedStall.show_logo)
//                       }
//                       className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
//                         selectedStall.show_logo ? "bg-blue-600" : "bg-gray-300"
//                       }`}
//                     >
//                       <span
//                         className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
//                           selectedStall.show_logo
//                             ? "translate-x-6"
//                             : "translate-x-1"
//                         }`}
//                       />
//                     </button>
//                   </div>
//                   {selectedStall.show_logo && (
//                     <div className="mt-2 flex items-center gap-2 rounded bg-blue-50 px-2 py-1.5 text-[11px] text-blue-700">
//                       <MdVisibility size={13} />
//                       Logo visible on mobile map
//                     </div>
//                   )}
//                   {!selectedStall.show_logo && (
//                     <div className="mt-2 flex items-center gap-2 rounded bg-gray-100 px-2 py-1.5 text-[11px] text-gray-500">
//                       <MdVisibilityOff size={13} />
//                       Only stall number shown
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="text-sm text-gray-500">
//               <p className="mb-3 font-semibold text-gray-700">How to use</p>
//               <div className="mb-3 rounded bg-blue-50 p-2.5 text-xs leading-relaxed text-blue-800">
//                 <strong>Select mode</strong> — click to select, drag to move
//                 <br />
//                 <strong>Draw mode</strong> — click to place vertices
//                 <br />
//                 Use <strong>Shape buttons</strong> above for instant shapes
//               </div>
//               <ul className="list-disc pl-4 text-xs leading-relaxed">
//                 <li>Click green dot to close polygon</li>
//                 <li>
//                   <kbd className="rounded border px-1 text-[10px]">Enter</kbd>{" "}
//                   close ·{" "}
//                   <kbd className="rounded border px-1 text-[10px]">Esc</kbd>{" "}
//                   cancel
//                 </li>
//                 <li>
//                   <kbd className="rounded border px-1 text-[10px]">Del</kbd>{" "}
//                   remove selected
//                 </li>
//                 <li>Scroll to zoom · drag canvas to pan</li>
//               </ul>
//               <div className="mt-4 rounded border border-gray-200 bg-gray-50 p-2.5">
//                 <p className="mb-1.5 text-xs font-medium text-gray-600">
//                   Stall Types
//                 </p>
//                 <div className="flex flex-wrap gap-1">
//                   {STALL_TYPES.map((t) => (
//                     <div key={t.value} className="flex items-center gap-1">
//                       <div
//                         className="h-2.5 w-2.5 rounded-full border border-gray-300"
//                         style={{ backgroundColor: t.color }}
//                       />
//                       <span className="text-[10px] text-gray-500">
//                         {t.label}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <p className="mt-3 text-xs font-medium text-gray-400">
//                 {stalls.length} shape{stalls.length !== 1 ? "s" : ""} on this
//                 floor
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import { useState, useEffect, useRef, useCallback, useMemo, memo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  MdArrowBack,
  MdArrowUpward,
  MdArrowDownward,
  MdArrowForward,
  MdSave,
  MdDelete,
  MdUpload,
  MdUndo,
  MdPanTool,
  MdEdit,
  MdClose,
  MdVisibility,
  MdVisibilityOff,
  MdImage,
} from "react-icons/md";
import Alert from "components/common/Alert";
import { getImageUrl } from "utils/imageHelper";
import { useFloorMap } from "./hooks/useFloorMap";
import {
  getStalls as fetchStalls,
  saveStalls as apiSaveStalls,
  updateFloorMap as apiUpdateFloorMap,
} from "api/floorMap.api";
import { getExhibitor } from "api/exhibitor.api";

const CANVAS_W = 1200;
const CANVAS_H = 800;

const STALL_TYPES = [
  { value: "stall", label: "Stall", color: "#93c5fd" },
  { value: "stage", label: "Stage", color: "#c4b5fd" },
  { value: "auditorium", label: "Auditorium", color: "#a5b4fc" },
  { value: "cafe", label: "Café", color: "#f9a8d4" },
  { value: "toilet", label: "Toilet", color: "#86efac" },
  { value: "parking", label: "Parking", color: "#fde68a" },
  { value: "entrance", label: "Entrance", color: "#6ee7b7" },
  { value: "exit", label: "Exit", color: "#fca5a5" },
  { value: "info", label: "Info Point", color: "#67e8f9" },
  { value: "corridor", label: "Corridor", color: "#d1d5db" },
  { value: "tree", label: "Tree / Park", color: "#4ade80" },
  { value: "fountain", label: "Fountain", color: "#38bdf8" },
  { value: "smoking", label: "Smoking Area", color: "#9ca3af" },
  { value: "label", label: "Text Label", color: "transparent" },
  { value: "other", label: "Other", color: "#e5e7eb" },
];

const typeColor = (type) =>
  STALL_TYPES.find((t) => t.value === type)?.color ?? "#93c5fd";

let _tid = 0;
const nextId = () => `tmp_${++_tid}`;

const stallToUI = (s) => ({
  id: s._id,
  stall_number: s.stall_number,
  stall_name: s.stall_name,
  type: s.type,
  points: s.points,
  color: s.color,
  image: s.image ?? null,
  font_size: s.font_size ?? 11,
  font_color: s.font_color ?? "#1e293b",
  font_weight: s.font_weight ?? "bold",
  show_logo: s.show_logo ?? false,
  exhibitor_id: s.exhibitor_id?._id || s.exhibitor_id || null,
  exhibitor_name: s.exhibitor_id?.title || "",
  exhibitor_logo: s.exhibitor_id?.logo_image || "",
});

const StallShape = memo(function StallShape({ stall, isSel, mode }) {
  const xs = stall.points.map((p) => p[0]);
  const ys = stall.points.map((p) => p[1]);
  const minX = Math.min(...xs);
  const minY = Math.min(...ys);
  const maxX = Math.max(...xs);
  const maxY = Math.max(...ys);
  const bw = maxX - minX;
  const bh = maxY - minY;
  const cx = minX + bw / 2;
  const cy = minY + bh / 2;

  const imageUrl = stall.image ? getImageUrl(stall.image) : null;
  const logoUrl =
    !imageUrl && stall.show_logo && stall.exhibitor_logo
      ? getImageUrl(stall.exhibitor_logo)
      : null;
  const logoR = Math.max(Math.min(Math.min(bw, bh) * 0.28, 20), 4);
  const polyPoints = stall.points.map(([x, y]) => `${x},${y}`).join(" ");

  if (stall.type === "label") {
    const hasBg = stall.color && stall.color !== "transparent";

    return (
      <g
        data-stall-id={stall.id}
        style={{
          cursor:
            mode === "select" ? (isSel ? "grab" : "pointer") : "crosshair",
        }}
      >
        <polygon
          points={polyPoints}
          fill={hasBg ? stall.color : "none"}
          fillOpacity={hasBg ? 0.75 : 0}
          stroke={isSel ? "#1d4ed8" : "none"}
          strokeWidth={isSel ? 0.8 : 0}
          strokeDasharray={isSel && !hasBg ? "4 2" : "none"}
          pointerEvents="all"
        />
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={stall.font_size ?? 16}
          fill={stall.font_color ?? "#000000"}
          fontWeight={stall.font_weight ?? "bold"}
          pointerEvents="all"
        >
          {stall.stall_name || stall.stall_number}
        </text>
      </g>
    );
  }

  return (
    <g
      data-stall-id={stall.id}
      style={{
        cursor: mode === "select" ? (isSel ? "grab" : "pointer") : "crosshair",
      }}
    >
      {imageUrl ? (
        <>
          <clipPath id={`clip-img-${stall.id}`}>
            <polygon points={polyPoints} />
          </clipPath>
          <image
            href={imageUrl}
            x={minX}
            y={minY}
            width={bw}
            height={bh}
            preserveAspectRatio="xMidYMid meet"
            clipPath={`url(#clip-img-${stall.id})`}
          />
          {isSel && (
            <polygon
              points={polyPoints}
              fill="none"
              stroke="#1d4ed8"
              strokeWidth={0.5}
            />
          )}
        </>
      ) : (
        <polygon
          points={polyPoints}
          fill={stall.color}
          fillOpacity={0.75}
          stroke={isSel ? "#1d4ed8" : "#475569"}
          strokeWidth={0.3}
        />
      )}
      {!imageUrl && !logoUrl && (
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={stall.font_size ?? 11}
          fill={stall.font_color ?? "#1e293b"}
          fontWeight={stall.font_weight ?? (isSel ? "600" : "400")}
          pointerEvents="none"
        >
          {stall.stall_number}
        </text>
      )}
      {!imageUrl && logoUrl && (
        <>
          <clipPath id={`clip-${stall.id}`}>
            <circle cx={cx} cy={cy} r={logoR} />
          </clipPath>
          <image
            href={logoUrl}
            x={cx - logoR}
            y={cy - logoR}
            width={logoR * 2}
            height={logoR * 2}
            preserveAspectRatio="xMidYMid slice"
            clipPath={`url(#clip-${stall.id})`}
            pointerEvents="none"
          />
        </>
      )}
    </g>
  );
});

export default function MapBuilder() {
  const { id } = useParams();
  const navigate = useNavigate();
  const svgRef = useRef(null);
  const bgInputRef = useRef(null);
  const stallImageInputRef = useRef(null);
  const panRef = useRef(null);
  const didPanRef = useRef(false);
  const dragRef = useRef(null);
  const dragGroupRef = useRef(null);
  const didDragRef = useRef(false);
  const cursorPtRef = useRef(null);
  const cursorLine1Ref = useRef(null);
  const cursorLine2Ref = useRef(null);
  const containerRef = useRef(null);
  const wrapperRef = useRef(null);
  const zoomRef = useRef(1);
  const panXRef = useRef(0);
  const panYRef = useRef(0);
  const zoomTimerRef = useRef(null);

  const {
    currentMap,
    loadFloorMapById,
    uploadFloorBackground,
    uploadStallImage,
    togglePublish,
  } = useFloorMap();

  const [floors, setFloors] = useState([]);
  const [activeFloor, setActiveFloor] = useState(null);
  const [mapName, setMapName] = useState("");
  const [mapStatus, setMapStatus] = useState("draft");

  const [zoom, setZoom] = useState(1);
  const [isPanning, setIsPanning] = useState(false);
  const [isDraggingStall, setIsDraggingStall] = useState(false);

  const [mode, setMode] = useState("select");
  const [stalls, setStalls] = useState([]);
  const [drawPts, setDrawPts] = useState([]);
  const [selected, setSelected] = useState(null);

  const [saving, setSaving] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [exhibitors, setExhibitors] = useState([]);
  const [step, setStep] = useState(5);

  const activeFloorData = floors.find((f) => f.floor_id === activeFloor);
  const bgImage = activeFloorData?.background_image
    ? getImageUrl(activeFloorData.background_image)
    : null;
  const zoomPct = Math.round(zoom * 100);
  const selectedStall = stalls.find((s) => s.id === selected) ?? null;

  const moveSelected = useCallback(
    (dx, dy) => {
      if (!selected) return;
      setStalls((p) =>
        p.map((s) =>
          s.id !== selected
            ? s
            : { ...s, points: s.points.map(([x, y]) => [x + dx, y + dy]) }
        )
      );
    },
    [selected]
  );

  const bbox = useMemo(() => {
    if (!selectedStall?.points?.length) return { w: 0, h: 0 };
    const xs = selectedStall.points.map((p) => p[0]);
    const ys = selectedStall.points.map((p) => p[1]);
    return {
      w: Math.round(Math.max(...xs) - Math.min(...xs)),
      h: Math.round(Math.max(...ys) - Math.min(...ys)),
    };
  }, [selectedStall]);

  const applyTransform = useCallback((z, px, py) => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `scale(${z}) translate(${-px}px, ${-py}px)`;
    }
  }, []);

  const fitCanvas = useCallback(() => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect || !rect.width) return;
    const z = Math.min(rect.width / CANVAS_W, rect.height / CANVAS_H);
    zoomRef.current = z;
    panXRef.current = 0;
    panYRef.current = 0;
    applyTransform(z, 0, 0);
    setZoom(z);
  }, [applyTransform]);

  useEffect(() => {
    fitCanvas();
  }, [fitCanvas]);

  useEffect(() => {
    if (id) loadFloorMapById(id);
  }, [id]);

  useEffect(() => {
    if (!currentMap) return;
    setMapName(currentMap.map_name);
    setMapStatus(currentMap.status);
    const fl = currentMap.floors || [];
    setFloors(fl);
    if (fl.length > 0) setActiveFloor((prev) => prev || fl[0].floor_id);
  }, [currentMap]);

  useEffect(() => {
    if (!id || !activeFloor) return;
    fetchStalls({ floor_map_id: id, floor_id: activeFloor })
      .then((res) => {
        setStalls((res.data?.data || []).map(stallToUI));
        setSelected(null);
        setDrawPts([]);
      })
      .catch(() => setStalls([]));
  }, [id, activeFloor]);

  useEffect(() => {
    const cid = localStorage.getItem("company_id");
    if (cid)
      getExhibitor(cid)
        .then((r) => setExhibitors(r?.data || []))
        .catch(() => {});
  }, []);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const onWheel = (e) => {
      e.preventDefault();
      const factor = e.deltaY > 0 ? 0.89 : 1.12;
      const rect = el.getBoundingClientRect();
      const z0 = zoomRef.current;
      const z1 = z0 * factor;
      const cx = (e.clientX - rect.left) / z0 + panXRef.current;
      const cy = (e.clientY - rect.top) / z0 + panYRef.current;
      panXRef.current = cx - (e.clientX - rect.left) / z1;
      panYRef.current = cy - (e.clientY - rect.top) / z1;
      zoomRef.current = z1;
      if (wrapperRef.current) {
        wrapperRef.current.style.transform = `scale(${z1}) translate(${-panXRef.current}px, ${-panYRef.current}px)`;
      }
      clearTimeout(zoomTimerRef.current);
      zoomTimerRef.current = setTimeout(() => setZoom(z1), 150);
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => {
      el.removeEventListener("wheel", onWheel);
      clearTimeout(zoomTimerRef.current);
    };
  }, []);

  const closePolygon = useCallback(() => {
    if (drawPts.length < 3) return;
    const newS = {
      id: nextId(),
      stall_number: `S${stalls.length + 1}`,
      stall_name: "",
      type: "stall",
      points: drawPts,
      color: typeColor("stall"),
      image: null,
      font_size: 11,
      font_color: "#1e293b",
      font_weight: "normal",
      show_logo: false,
      exhibitor_id: null,
      exhibitor_name: "",
      exhibitor_logo: "",
    };
    setStalls((p) => [...p, newS]);
    setSelected(newS.id);
    setMode("select");
    setDrawPts([]);
    cursorPtRef.current = null;
  }, [drawPts, stalls.length]);

  const deleteSelected = useCallback(() => {
    setStalls((p) => p.filter((s) => s.id !== selected));
    setSelected(null);
  }, [selected]);

  useEffect(() => {
    const onKey = (e) => {
      const tag = e.target.tagName;
      if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return;
      if (e.key === "Escape") {
        setDrawPts([]);
        cursorPtRef.current = null;
        setMode("select");
      }
      if (e.key === "Enter" && mode === "draw" && drawPts.length >= 3)
        closePolygon();
      if ((e.key === "Delete" || e.key === "Backspace") && selected)
        deleteSelected();
      const arrowStep = e.shiftKey ? 20 : e.ctrlKey ? 50 : step;
      if (selected) {
        if (e.key === "ArrowUp") {
          e.preventDefault();
          moveSelected(0, -arrowStep);
        }
        if (e.key === "ArrowDown") {
          e.preventDefault();
          moveSelected(0, arrowStep);
        }
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          moveSelected(-arrowStep, 0);
        }
        if (e.key === "ArrowRight") {
          e.preventDefault();
          moveSelected(arrowStep, 0);
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [
    mode,
    drawPts,
    selected,
    step,
    moveSelected,
    closePolygon,
    deleteSelected,
  ]);

  const resetCursorLines = () => {
    ["x1", "y1", "x2", "y2"].forEach((a) => {
      cursorLine1Ref.current?.setAttribute(a, "0");
      cursorLine2Ref.current?.setAttribute(a, "0");
    });
  };
  useEffect(() => {
    if (mode !== "draw" || drawPts.length === 0) resetCursorLines();
  }, [mode, drawPts.length]);

  const getCanvasPt = useCallback((e) => {
    const rect = containerRef.current?.getBoundingClientRect() ?? {
      left: 0,
      top: 0,
    };
    return [
      (e.clientX - rect.left) / zoomRef.current + panXRef.current,
      (e.clientY - rect.top) / zoomRef.current + panYRef.current,
    ];
  }, []);

  const toViewport = useCallback(([cx, cy]) => {
    const rect = containerRef.current?.getBoundingClientRect() ?? {
      left: 0,
      top: 0,
    };
    return [
      (cx - panXRef.current) * zoomRef.current + rect.left,
      (cy - panYRef.current) * zoomRef.current + rect.top,
    ];
  }, []);

  const handleSvgMouseDown = (e) => {
    if (mode === "select") {
      const stallGroup = e.target.closest("[data-stall-id]");
      if (stallGroup) {
        const stallId = stallGroup.dataset.stallId;
        setSelected(stallId);
        didDragRef.current = false;

        setStalls((latestStalls) => {
          const targetStall = latestStalls.find((s) => s.id === stallId);
          dragRef.current = {
            stallId,
            sx: e.clientX,
            sy: e.clientY,
            pts: targetStall?.points || [],
            moved: false,
          };
          return latestStalls;
        });

        dragGroupRef.current = stallGroup;
        setIsDraggingStall(true);
        return;
      }
      setIsPanning(true);
      didPanRef.current = false;
      panRef.current = {
        sx: e.clientX,
        sy: e.clientY,
        startPanX: panXRef.current,
        startPanY: panYRef.current,
      };
    }
  };

  const handleSvgMouseMove = (e) => {
    if (dragRef.current) {
      const d = dragRef.current;
      const z = zoomRef.current;
      const dx = (e.clientX - d.sx) / z;
      const dy = (e.clientY - d.sy) / z;
      if (Math.abs(e.clientX - d.sx) > 3 || Math.abs(e.clientY - d.sy) > 3) {
        d.moved = true;
        didDragRef.current = true;
      }
      d.lastDx = dx;
      d.lastDy = dy;
      if (dragGroupRef.current) {
        dragGroupRef.current.setAttribute(
          "transform",
          `translate(${dx},${dy})`
        );
      }
      return;
    }
    if (isPanning && panRef.current) {
      const p = panRef.current;
      const z = zoomRef.current;
      const dx = (e.clientX - p.sx) / z;
      const dy = (e.clientY - p.sy) / z;
      if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) didPanRef.current = true;
      panXRef.current = p.startPanX - dx;
      panYRef.current = p.startPanY - dy;
      if (wrapperRef.current) {
        wrapperRef.current.style.transform = `scale(${z}) translate(${-panXRef.current}px, ${-panYRef.current}px)`;
      }
    }
    if (mode === "draw") {
      const pt = getCanvasPt(e);
      cursorPtRef.current = pt;
      if (drawPts.length > 0) {
        const last = drawPts[drawPts.length - 1];
        if (cursorLine1Ref.current) {
          cursorLine1Ref.current.setAttribute("x1", String(last[0]));
          cursorLine1Ref.current.setAttribute("y1", String(last[1]));
          cursorLine1Ref.current.setAttribute("x2", String(pt[0]));
          cursorLine1Ref.current.setAttribute("y2", String(pt[1]));
          cursorLine1Ref.current.style.display = "";
        }
        if (drawPts.length >= 3 && cursorLine2Ref.current) {
          cursorLine2Ref.current.setAttribute("x1", String(drawPts[0][0]));
          cursorLine2Ref.current.setAttribute("y1", String(drawPts[0][1]));
          cursorLine2Ref.current.setAttribute("x2", String(pt[0]));
          cursorLine2Ref.current.setAttribute("y2", String(pt[1]));
          cursorLine2Ref.current.style.display = "";
        } else if (cursorLine2Ref.current) {
          cursorLine2Ref.current.style.display = "none";
        }
      }
    }
  };

  const handleSvgMouseUp = () => {
    if (dragRef.current?.moved && dragRef.current.lastDx !== undefined) {
      const d = dragRef.current;
      setStalls((prev) =>
        prev.map((s) =>
          s.id !== d.stallId
            ? s
            : {
                ...s,
                points: d.pts.map(([x, y]) => [x + d.lastDx, y + d.lastDy]),
              }
        )
      );
    }
    if (dragGroupRef.current) {
      dragGroupRef.current.removeAttribute("transform");
      dragGroupRef.current = null;
    }
    dragRef.current = null;
    setIsDraggingStall(false);
    setIsPanning(false);
  };

  const handleSvgClick = (e) => {
    if (mode === "select") {
      if (didPanRef.current || didDragRef.current) return;
      const stallGroup = e.target.closest("[data-stall-id]");
      if (stallGroup) {
        setSelected(stallGroup.dataset.stallId);
      } else {
        const tag = e.target.tagName;
        if (
          tag === "svg" ||
          tag === "image" ||
          tag === "rect" ||
          tag === "line"
        )
          setSelected(null);
      }
      return;
    }
    if (mode !== "draw") return;
    const pt = getCanvasPt(e);
    if (drawPts.length >= 3) {
      const [fpx, fpy] = toViewport(drawPts[0]);
      if (Math.hypot(e.clientX - fpx, e.clientY - fpy) < 16) {
        closePolygon();
        return;
      }
    }
    setDrawPts((prev) => [...prev, pt]);
  };

  const viewportCenter = () => {
    const rect = containerRef.current?.getBoundingClientRect();
    const cw = rect?.width ?? CANVAS_W;
    const ch = rect?.height ?? CANVAS_H;
    return [
      panXRef.current + cw / (2 * (zoomRef.current || 1)),
      panYRef.current + ch / (2 * (zoomRef.current || 1)),
    ];
  };

  const addStall = (points) => {
    const s = {
      id: nextId(),
      stall_number: `S${stalls.length + 1}`,
      stall_name: "",
      type: "stall",
      points,
      color: typeColor("stall"),
      image: null,
      font_size: 11,
      font_color: "#1e293b",
      font_weight: "normal",
      show_logo: false,
      exhibitor_id: null,
      exhibitor_name: "",
      exhibitor_logo: "",
    };
    setStalls((p) => [...p, s]);
    setSelected(s.id);
    setMode("select");
  };

  const addTextLabel = (cx, cy) => {
    const w = 140;
    const h = 50;
    const label = {
      id: nextId(),
      stall_number: `L${stalls.length + 1}`,
      stall_name: "Bakery / Road",
      type: "label",
      points: [
        [cx - w / 2, cy - h / 2],
        [cx + w / 2, cy - h / 2],
        [cx + w / 2, cy + h / 2],
        [cx - w / 2, cy + h / 2],
      ],
      color: "transparent",
      image: null,
      font_size: 16,
      font_color: "#000000",
      font_weight: "bold",
      show_logo: false,
      exhibitor_id: null,
      exhibitor_name: "",
      exhibitor_logo: "",
    };
    setStalls((p) => [...p, label]);
    setSelected(label.id);
    setMode("select");
  };

  const addRect = (w = 150, h = 100) => {
    const [cx, cy] = viewportCenter();
    addStall([
      [cx - w / 2, cy - h / 2],
      [cx + w / 2, cy - h / 2],
      [cx + w / 2, cy + h / 2],
      [cx - w / 2, cy + h / 2],
    ]);
  };
  const addSquare = (n = 100) => addRect(n, n);
  const addCircle = (r = 60) => {
    const [cx, cy] = viewportCenter();
    addStall(
      Array.from({ length: 16 }, (_, i) => {
        const a = (i / 16) * 2 * Math.PI;
        return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
      })
    );
  };
  const addTriangle = (n = 120) => {
    const [cx, cy] = viewportCenter();
    addStall([
      [cx, cy - n * 0.6],
      [cx + n / 2, cy + n * 0.4],
      [cx - n / 2, cy + n * 0.4],
    ]);
  };
  const addLShape = (n = 120) => {
    const [cx, cy] = viewportCenter();
    addStall([
      [cx - n / 2, cy - n / 2],
      [cx, cy - n / 2],
      [cx, cy],
      [cx + n / 2, cy],
      [cx + n / 2, cy + n / 2],
      [cx - n / 2, cy + n / 2],
    ]);
  };

  const updateSel = (field, val) =>
    setStalls((p) =>
      p.map((s) => {
        if (s.id !== selected) return s;
        const u = { ...s, [field]: val };
        if (field === "type") u.color = typeColor(val);
        if (field === "exhibitor_id") {
          const ex = exhibitors.find((e) => e._id === val);
          u.exhibitor_name = ex?.title || "";
          u.exhibitor_logo = ex?.logo_image || "";
          if (!val) u.show_logo = false;
        }
        return u;
      })
    );

  const resizeSel = (nw, nh) => {
    if (!selectedStall || nw <= 0 || nh <= 0) return;
    const xs = selectedStall.points.map((p) => p[0]);
    const ys = selectedStall.points.map((p) => p[1]);
    const cx = (Math.min(...xs) + Math.max(...xs)) / 2;
    const cy = (Math.min(...ys) + Math.max(...ys)) / 2;
    const ow = Math.max(...xs) - Math.min(...xs);
    const oh = Math.max(...ys) - Math.min(...ys);
    if (!ow || !oh) return;
    setStalls((p) =>
      p.map((s) =>
        s.id !== selected
          ? s
          : {
              ...s,
              points: s.points.map(([x, y]) => [
                cx + (x - cx) * (nw / ow),
                cy + (y - cy) * (nh / oh),
              ]),
            }
      )
    );
  };

  const handleBgUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !activeFloor) return;
    try {
      const res = await uploadFloorBackground(id, activeFloor, file);
      const imgPath = res.data?.background_image;
      if (imgPath)
        setFloors((p) =>
          p.map((f) =>
            f.floor_id === activeFloor ? { ...f, background_image: imgPath } : f
          )
        );
      setAlert({ type: "success", message: "Background uploaded" });
    } catch {
      setAlert({ type: "error", message: "Upload failed" });
    } finally {
      e.target.value = "";
    }
  };

  const handleRemoveBg = async () => {
    const updated = floors.map((f) =>
      f.floor_id === activeFloor ? { ...f, background_image: null } : f
    );
    try {
      await apiUpdateFloorMap(id, {
        floors: updated,
        updated_by: localStorage.getItem("user_id") || null,
      });
      setFloors(updated);
      setAlert({ type: "success", message: "Background removed" });
    } catch {
      setAlert({ type: "error", message: "Failed to remove background" });
    }
  };

  const handleStallImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !selected) return;
    try {
      const res = await uploadStallImage(file);
      const imgPath = res.data?.image;
      if (imgPath) updateSel("image", imgPath);
      setAlert({ type: "success", message: "Image uploaded" });
    } catch {
      setAlert({ type: "error", message: "Image upload failed" });
    } finally {
      e.target.value = "";
    }
  };

  const handleRemoveStallImage = () => updateSel("image", null);

  const handleSave = async () => {
    setSaving(true);
    try {
      await apiSaveStalls({
        floor_map_id: id,
        floor_id: activeFloor,
        company_id: localStorage.getItem("company_id") || null,
        updated_by: localStorage.getItem("user_id") || null,
        stalls: stalls.map(
          ({
            stall_number,
            stall_name,
            type,
            points,
            color,
            image,
            font_size,
            font_color,
            font_weight,
            show_logo,
            exhibitor_id,
          }) => ({
            stall_number,
            stall_name,
            type,
            points,
            color,
            image: image || null,
            font_size: font_size ?? 11,
            font_color: font_color ?? "#1e293b",
            font_weight: font_weight ?? "bold",
            show_logo: show_logo ?? false,
            exhibitor_id: exhibitor_id || null,
          })
        ),
      });
      setAlert({ type: "success", message: "Stalls saved" });
      const r = await fetchStalls({ floor_map_id: id, floor_id: activeFloor });
      setStalls((r.data?.data || []).map(stallToUI));
    } catch {
      setAlert({ type: "error", message: "Failed to save stalls" });
    } finally {
      setSaving(false);
    }
  };

  const handlePublish = async () => {
    const newStatus = mapStatus === "published" ? "draft" : "published";
    try {
      await togglePublish(id, {
        status: newStatus,
        updated_by: localStorage.getItem("user_id") || null,
      });
      setMapStatus(newStatus);
      setAlert({
        type: "success",
        message: newStatus === "published" ? "Map published" : "Set to draft",
      });
    } catch {
      setAlert({ type: "error", message: "Failed to update status" });
    }
  };

  return (

      <div className="flex h-[calc(100vh-100px)] w-full flex-col overflow-hidden rounded-2xl border border-gray-200 bg-gray-100 shadow-sm">
        {alert.message && (
          <Alert
            type={alert.type}
            message={alert.message}
            onClose={() => setAlert({ type: "", message: "" })}
            autoClose
          />
        )}

        {/* ── Top bar ── */}
        <div className="flex shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 py-2 shadow-sm">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/admin/floor-map")}
              className="flex items-center gap-1 rounded px-2 py-1 text-sm text-gray-600 hover:bg-gray-100"
            >
              <MdArrowBack size={18} /> Back
            </button>
            <span className="font-semibold text-gray-800">{mapName}</span>
            <span
              className={`rounded-full px-2 py-0.5 text-xs font-medium ${
                mapStatus === "published"
                  ? "bg-green-100 text-green-700"
                  : "bg-yellow-100 text-yellow-700"
              }`}
            >
              {mapStatus}
            </span>
          </div>

          <div className="flex flex-wrap items-center justify-end gap-2">
            <div className="flex overflow-hidden rounded border border-gray-300">
              {[
                ["select", "Select", <MdPanTool size={13} key="pan" />],
                ["draw", "Draw", <MdEdit size={13} key="edit" />],
              ].map(([m, lbl, ico]) => (
                <button
                  key={m}
                  className={`flex items-center gap-1 px-3 py-1.5 text-sm ${
                    mode === m
                      ? "bg-blue-600 text-white"
                      : "bg-white text-gray-600 hover:bg-gray-50"
                  }`}
                  onClick={() => {
                    setMode(m);
                    setDrawPts([]);
                  }}
                >
                  {ico} {lbl}
                </button>
              ))}
            </div>

            <div className="flex items-center gap-1 rounded border border-gray-200 bg-gray-50 px-2 py-1">
              <span className="mr-1 text-xs text-gray-400">Shape:</span>
              {[
                ["Rect", () => addRect()],
                ["Square", () => addSquare()],
                ["Circle", () => addCircle()],
                ["Tri", () => addTriangle()],
                ["L", () => addLShape()],
              ].map(([lbl, fn]) => (
                <button
                  key={lbl}
                  onClick={fn}
                  className="rounded border border-gray-300 bg-white px-2 py-0.5 text-xs hover:border-blue-300 hover:bg-blue-50"
                >
                  {lbl}
                </button>
              ))}
            </div>

            <button
              onClick={fitCanvas}
              className="rounded border border-gray-300 px-2 py-1.5 text-xs text-gray-600 hover:bg-gray-50"
            >
              Fit
            </button>

            <button
              onClick={handlePublish}
              className={`rounded px-3 py-1.5 text-sm text-white ${
                mapStatus === "published"
                  ? "bg-yellow-500 hover:bg-yellow-600"
                  : "bg-green-600 hover:bg-green-700"
              }`}
            >
              {mapStatus === "published" ? "Unpublish" : "Publish"}
            </button>

            <button
              onClick={() => {
                const [cx, cy] = viewportCenter();
                addTextLabel(cx, cy);
              }}
              className="flex items-center gap-1 rounded border border-gray-300 px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-50"
            >
              <MdEdit size={16} /> Add Text/Area
            </button>

            <button
              onClick={handleSave}
              disabled={saving}
              className="flex items-center gap-1 rounded bg-blue-600 px-4 py-1.5 text-sm text-white hover:bg-blue-700 disabled:opacity-60"
            >
              <MdSave size={16} />
              {saving ? "Saving…" : "Save Floor"}
            </button>
          </div>
        </div>

        {/* ── Floor tabs ── */}
        <div className="flex min-h-[36px] shrink-0 items-center gap-1 border-b border-gray-200 bg-white px-4 py-1">
          {floors.map((f) => (
            <button
              key={f.floor_id}
              onClick={() => {
                setActiveFloor(f.floor_id);
                setSelected(null);
                setDrawPts([]);
              }}
              className={`rounded-t px-4 py-1 text-sm font-medium ${
                activeFloor === f.floor_id
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {f.floor_label}
            </button>
          ))}

          <div className="ml-auto flex items-center gap-2">
            {mode === "draw" && drawPts.length > 0 && (
              <>
                <span className="text-xs font-medium text-blue-600">
                  {drawPts.length} pts — click green dot or Enter to close
                </span>
                <button
                  onClick={() => setDrawPts((p) => p.slice(0, -1))}
                  className="flex items-center gap-1 rounded border border-gray-300 px-2 py-0.5 text-xs hover:bg-gray-50"
                >
                  <MdUndo size={13} /> Undo
                </button>
                <button
                  onClick={closePolygon}
                  disabled={drawPts.length < 3}
                  className="rounded bg-blue-600 px-2 py-0.5 text-xs text-white hover:bg-blue-700 disabled:opacity-50"
                >
                  Close (Enter)
                </button>
              </>
            )}
            <input
              ref={bgInputRef}
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleBgUpload}
            />
            <button
              onClick={() => bgInputRef.current?.click()}
              className="flex items-center gap-1 rounded border border-gray-300 px-2 py-0.5 text-xs text-gray-600 hover:bg-gray-50"
            >
              <MdUpload size={13} /> Upload BG
            </button>
            {activeFloorData?.background_image && (
              <button
                onClick={handleRemoveBg}
                className="flex items-center gap-1 rounded border border-red-300 px-2 py-0.5 text-xs text-red-600 hover:bg-red-50"
              >
                <MdClose size={13} /> Remove BG
              </button>
            )}
          </div>
        </div>

        {/* ── Main ── */}
        <div className="flex flex-1 overflow-hidden">
          {/* Canvas */}
          <div className="relative flex-1 overflow-hidden bg-gray-300">
            {mode === "draw" && drawPts.length === 0 && (
              <div className="pointer-events-none absolute left-1/2 top-3 z-10 -translate-x-1/2 rounded bg-blue-600 px-3 py-1 text-xs text-white shadow">
                Click canvas to start drawing · use preset shapes above for
                quick add
              </div>
            )}
            <div className="absolute bottom-2 right-2 z-10 rounded bg-white/80 px-2 py-0.5 text-xs text-gray-500 shadow">
              {zoomPct}% · {stalls.length} shape{stalls.length !== 1 ? "s" : ""}
            </div>

            {/* D-pad */}
            {selectedStall && (
              <div className="absolute bottom-10 left-4 z-10 select-none rounded-xl border border-gray-200 bg-white/95 p-2 shadow-lg">
                <div className="mb-0.5 flex justify-center">
                  <button
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => moveSelected(0, -step)}
                    className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
                  >
                    <MdArrowUpward size={18} />
                  </button>
                </div>
                <div className="mb-0.5 flex items-center gap-0.5">
                  <button
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => moveSelected(-step, 0)}
                    className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
                  >
                    <MdArrowBack size={18} />
                  </button>
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gray-100 text-xs font-semibold text-gray-500">
                    {step}
                  </div>
                  <button
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => moveSelected(step, 0)}
                    className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
                  >
                    <MdArrowForward size={18} />
                  </button>
                </div>
                <div className="mb-1.5 flex justify-center">
                  <button
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={() => moveSelected(0, step)}
                    className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700 transition-colors hover:border-blue-400 hover:bg-blue-50 active:bg-blue-100"
                  >
                    <MdArrowDownward size={18} />
                  </button>
                </div>
                <div className="flex items-center justify-center gap-1">
                  {[1, 5, 10, 20].map((s) => (
                    <button
                      key={s}
                      onMouseDown={(e) => e.stopPropagation()}
                      onClick={() => setStep(s)}
                      className={`h-5 w-7 rounded text-[10px] font-medium transition-colors ${
                        step === s
                          ? "bg-blue-600 text-white"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      {s}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div
              ref={containerRef}
              className="absolute inset-0 overflow-hidden"
              style={{
                cursor:
                  mode === "draw"
                    ? "crosshair"
                    : isDraggingStall || isPanning
                    ? "grabbing"
                    : "grab",
              }}
              onMouseDown={handleSvgMouseDown}
              onMouseMove={handleSvgMouseMove}
              onMouseUp={handleSvgMouseUp}
              onMouseLeave={handleSvgMouseUp}
              onClick={handleSvgClick}
            >
              <div
                ref={wrapperRef}
                style={{
                  transformOrigin: "0 0",
                  willChange: "transform",
                  position: "absolute",
                }}
              >
                <svg
                  ref={svgRef}
                  width={CANVAS_W}
                  height={CANVAS_H}
                  style={{ display: "block", overflow: "visible" }}
                >
                  {bgImage ? (
                    <image
                      href={bgImage}
                      x={0}
                      y={0}
                      width={CANVAS_W}
                      height={CANVAS_H}
                      preserveAspectRatio="xMidYMid meet"
                    />
                  ) : (
                    <>
                      <rect
                        x={0}
                        y={0}
                        width={CANVAS_W}
                        height={CANVAS_H}
                        fill="#f8fafc"
                        stroke="#e2e8f0"
                        strokeWidth={1}
                      />
                      <text
                        x={CANVAS_W / 2}
                        y={CANVAS_H / 2}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontSize={14}
                        fill="#94a3b8"
                      >
                        No background — upload a floor plan image (optional)
                      </text>
                    </>
                  )}

                  {Array.from({ length: 11 }, (_, i) => (
                    <line
                      key={`v${i}`}
                      x1={(i + 1) * 100}
                      y1={0}
                      x2={(i + 1) * 100}
                      y2={CANVAS_H}
                      stroke="#e2e8f0"
                      strokeWidth={0.5}
                    />
                  ))}
                  {Array.from({ length: 7 }, (_, i) => (
                    <line
                      key={`h${i}`}
                      x1={0}
                      y1={(i + 1) * 100}
                      x2={CANVAS_W}
                      y2={(i + 1) * 100}
                      stroke="#e2e8f0"
                      strokeWidth={0.5}
                    />
                  ))}

                  {stalls.map((stall) => (
                    <StallShape
                      key={stall.id}
                      stall={stall}
                      isSel={stall.id === selected}
                      mode={mode}
                    />
                  ))}

                  <line
                    ref={cursorLine1Ref}
                    stroke="#2563eb"
                    strokeWidth={1.5}
                    strokeDasharray="4 2"
                    pointerEvents="none"
                  />
                  <line
                    ref={cursorLine2Ref}
                    stroke="#16a34a"
                    strokeWidth={1}
                    strokeDasharray="4 2"
                    strokeOpacity={0.5}
                    pointerEvents="none"
                  />

                  {drawPts.length > 0 && (
                    <>
                      {drawPts.length >= 2 && (
                        <polyline
                          points={drawPts
                            .map(([x, y]) => `${x},${y}`)
                            .join(" ")}
                          fill="none"
                          stroke="#2563eb"
                          strokeWidth={1.5}
                          strokeDasharray="6 3"
                          pointerEvents="none"
                        />
                      )}
                      {drawPts.map(([x, y], i) => (
                        <circle
                          key={i}
                          cx={x}
                          cy={y}
                          r={i === 0 ? 7 : 4}
                          fill={i === 0 ? "#16a34a" : "#2563eb"}
                          stroke="white"
                          strokeWidth={1.5}
                          pointerEvents="none"
                        />
                      ))}
                    </>
                  )}
                </svg>
              </div>
            </div>
          </div>

          {/* ── Properties panel ── */}
          <div className="w-64 shrink-0 overflow-y-auto border-l border-gray-200 bg-white p-4">
            {selectedStall ? (
              <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-gray-800">Properties</h3>
                  <button
                    onClick={deleteSelected}
                    title="Delete (Del)"
                    className="rounded p-1 text-red-500 hover:bg-red-50"
                  >
                    <MdDelete size={18} />
                  </button>
                </div>

                {[
                  ["Stall/Label Number", "stall_number"],
                  ["Display Name (Text)", "stall_name"],
                ].map(([lbl, field]) => (
                  <div key={field}>
                    <label className="mb-1 block text-xs font-medium text-gray-600">
                      {lbl}
                    </label>
                    <input
                      className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={selectedStall[field]}
                      onChange={(e) => updateSel(field, e.target.value)}
                      placeholder={
                        field === "stall_name" ? "e.g. Bakery, Road..." : ""
                      }
                    />
                  </div>
                ))}

                <div>
                  <label className="mb-1 block text-xs font-medium text-gray-600">
                    Type
                  </label>
                  <select
                    className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={selectedStall.type}
                    onChange={(e) => updateSel("type", e.target.value)}
                  >
                    {STALL_TYPES.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="mb-1 block text-xs font-medium text-gray-600">
                    Size (W × H)
                  </label>
                  <div className="flex items-center gap-1">
                    <input
                      type="number"
                      min={10}
                      max={CANVAS_W}
                      className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={bbox.w}
                      onChange={(e) =>
                        resizeSel(Number(e.target.value), bbox.h)
                      }
                    />
                    <span className="shrink-0 text-gray-400">×</span>
                    <input
                      type="number"
                      min={10}
                      max={CANVAS_H}
                      className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={bbox.h}
                      onChange={(e) =>
                        resizeSel(bbox.w, Number(e.target.value))
                      }
                    />
                  </div>
                </div>

                {selectedStall.type !== "label" && (
                  <div>
                    <label className="mb-1 block text-xs font-medium text-gray-600">
                      Box Image
                    </label>
                    {selectedStall.image ? (
                      <div className="flex items-center gap-2">
                        <img
                          src={getImageUrl(selectedStall.image)}
                          alt="Box"
                          className="h-12 w-12 rounded border border-gray-300 object-cover"
                        />
                        <button
                          onClick={handleRemoveStallImage}
                          className="flex items-center gap-1 rounded border border-red-300 px-2 py-1 text-xs text-red-600 hover:bg-red-50"
                        >
                          <MdClose size={13} /> Remove
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => stallImageInputRef.current?.click()}
                        className="flex w-full items-center justify-center gap-1 rounded border border-dashed border-gray-300 px-2 py-2 text-xs text-gray-500 hover:border-blue-400 hover:text-blue-600"
                      >
                        <MdImage size={14} /> Upload image
                      </button>
                    )}
                    <input
                      ref={stallImageInputRef}
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleStallImageUpload}
                    />
                  </div>
                )}

                <div>
                  <label className="mb-1 block text-xs font-medium text-gray-600">
                    Background Color
                  </label>
                  <div className="flex items-center gap-2">
                    <input
                      type="color"
                      className="h-8 w-10 cursor-pointer rounded border border-gray-300"
                      value={
                        selectedStall.color === "transparent"
                          ? "#ffffff"
                          : selectedStall.color
                      }
                      onChange={(e) => updateSel("color", e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => updateSel("color", "transparent")}
                      className="rounded border border-gray-300 px-2 py-1 text-xs text-gray-600 hover:bg-gray-50"
                    >
                      Clear (Transparent)
                    </button>
                  </div>
                </div>

                {/* ✅ Font Controls with Bold Button added */}
                <div>
                  <label className="mb-1 block text-xs font-medium text-gray-600">
                    Text Font Style
                  </label>
                  <div className="flex items-center gap-2">
                    <div className="flex flex-1 flex-col gap-0.5">
                      <span className="text-[10px] text-gray-400">Size</span>
                      <input
                        type="number"
                        min={1}
                        max={48}
                        className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={selectedStall.font_size ?? 16}
                        onChange={(e) =>
                          updateSel(
                            "font_size",
                            Math.max(1, Math.min(48, Number(e.target.value)))
                          )
                        }
                      />
                    </div>
                    <div className="flex flex-col gap-0.5">
                      <span className="text-[10px] text-gray-400">Color</span>
                      <input
                        type="color"
                        className="h-[34px] w-10 cursor-pointer rounded border border-gray-300"
                        value={selectedStall.font_color ?? "#000000"}
                        onChange={(e) =>
                          updateSel("font_color", e.target.value)
                        }
                      />
                    </div>
                    <div className="flex flex-col gap-0.5">
                      <span className="text-[10px] text-gray-400">Weight</span>
                      <button
                        type="button"
                        onClick={() =>
                          updateSel(
                            "font_weight",
                            selectedStall.font_weight === "bold"
                              ? "normal"
                              : "bold"
                          )
                        }
                        className={`h-[34px] w-10 rounded border text-sm font-extrabold transition-colors ${
                          selectedStall.font_weight === "bold"
                            ? "border-blue-600 bg-blue-600 text-white"
                            : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                        }`}
                        title="Toggle Bold Text"
                      >
                        B
                      </button>
                    </div>
                  </div>
                </div>

                {selectedStall.type !== "label" && (
                  <>
                    <div>
                      <label className="mb-1 block text-xs font-medium text-gray-600">
                        Exhibitor
                      </label>
                      <select
                        className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={selectedStall.exhibitor_id || ""}
                        onChange={(e) =>
                          updateSel("exhibitor_id", e.target.value || null)
                        }
                      >
                        <option value="">— None —</option>
                        {exhibitors.map((ex) => (
                          <option key={ex._id} value={ex._id}>
                            {ex.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    {selectedStall.exhibitor_id && (
                      <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="text-xs font-semibold text-gray-700">
                              Show Logo on Map
                            </p>
                            <p className="mt-0.5 text-[11px] text-gray-400">
                              Display exhibitor logo over this stall
                            </p>
                          </div>
                          <button
                            onClick={() =>
                              updateSel("show_logo", !selectedStall.show_logo)
                            }
                            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
                              selectedStall.show_logo
                                ? "bg-blue-600"
                                : "bg-gray-300"
                            }`}
                          >
                            <span
                              className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                                selectedStall.show_logo
                                  ? "translate-x-6"
                                  : "translate-x-1"
                              }`}
                            />
                          </button>
                        </div>
                        {selectedStall.show_logo && (
                          <div className="mt-2 flex items-center gap-2 rounded bg-blue-50 px-2 py-1.5 text-[11px] text-blue-700">
                            <MdVisibility size={13} />
                            Logo visible on mobile map
                          </div>
                        )}
                        {!selectedStall.show_logo && (
                          <div className="mt-2 flex items-center gap-2 rounded bg-gray-100 px-2 py-1.5 text-[11px] text-gray-500">
                            <MdVisibilityOff size={13} />
                            Only stall number shown
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            ) : (
              <div className="text-sm text-gray-500">
                <p className="mb-3 font-semibold text-gray-700">How to use</p>
                <div className="mb-3 rounded bg-blue-50 p-2.5 text-xs leading-relaxed text-blue-800">
                  <strong>Select mode</strong> — click to select, drag to move
                  <br />
                  <strong>Draw mode</strong> — click to place vertices
                  <br />
                  Use <strong>Shape buttons</strong> or{" "}
                  <strong>Add Text/Area</strong> for labels like Bakery/Road
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

  );
}
